import { render, staticRenderFns } from "./pWareList.vue?vue&type=template&id=4eed4e12&scoped=true"
import script from "./pWareList.vue?vue&type=script&lang=js"
export * from "./pWareList.vue?vue&type=script&lang=js"
import style0 from "./pWareList.vue?vue&type=style&index=0&id=4eed4e12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eed4e12",
  null
  
)

export default component.exports